import { useFaqStore } from '../accordion/faq_store.js';
import { convertDataVToVue } from '../apply_vue_data_directives.js';
import { initFaqForms } from '../organism/organism_faq.js';

export class FaqSearchGroupSearch {
	constructor(component_id) {
		this.id = component_id;
		this.$root = document.querySelector('.js-' + this.id);
		this.vars = (yalwa.v.components && yalwa.v.components[this.id]) || {};
	}

	init() {}

	vue_setup(Vue) {
		if (!this.$root) return {};
		const store = useFaqStore(Vue);
		const rootEl = this.$root;
		store.searchLabels.results = this.vars.results_label || '';
		store.searchLabels.no_results = this.vars.no_results_label || '';
		store.searchLabels.min_chars = this.vars.min_chars_label || '';

		const $organism = jQuery(this.$root).closest('.organism--faq');

		$organism.find('.accordion__item').each(function() {
			const $item = jQuery(this);
			const $linkEl = $item.find('.accordion__link');
			const rawHash = $linkEl.attr('href') || '';
			if (!rawHash.startsWith('#') || rawHash.startsWith('#popular_')) return;
			const $titleEl = $item.find('.accordion__title').first();
			const $contentEl = $item.find('.accordion__content').first();
			const $feedbackEl = $item.find('.faq_feedback').first();
			const hash = '#search_' + rawHash.slice(1);

			store.searchItems[hash] = {
				hash: hash,
				title: $titleEl.html() || $titleEl.text(),
				body: ($contentEl.html() || '') + ($feedbackEl.length ? $feedbackEl[0].outerHTML : ''),
				link: hash,
			};

			const text = ($linkEl.attr('href') ? $linkEl.text() : $titleEl.text())
				.replace(/\s+/g, ' ').toLowerCase();
			store.searchTexts[hash] = text;
		});

		Vue.watch(() => store.searchQuery, () => {
			const q = (store.searchQuery || '').replace(/\s+/g, ' ').toLowerCase().trim();
			store.searchResultCount = 0;
			store.searchResults = [];
			if (q.length < 2) return;

			const results = [];
			jQuery(this.$root).closest('.organism--faq').find('.accordion__item').each(function() {
				const $link = jQuery(this).find('.accordion__link');
				const rawHash = $link.attr('href') || jQuery(this).find('.accordion__title').text().trim();
				const hash = rawHash.startsWith('#') ? '#search_' + rawHash.slice(1) : rawHash;
				const text = store.searchTexts[hash] || '';
				if (text.indexOf(q) !== -1) {
					const item = store.searchItems[hash];
				if (item) {
					const cleanHash = hash.replace('#search_', '#').replace('#search_popular_', '#popular_');
					if (!results.find(r => r.cleanHash === cleanHash)) {
						item.cleanHash = cleanHash;
						results.push(item);
					}
				}
				}
			});
			store.searchResults = results;
			store.searchResultCount = results.length;
			Vue.nextTick(() => initFaqForms(jQuery(rootEl)));
		});

		const template = convertDataVToVue(this.$root);

		return Vue.defineComponent({
			name: this.id,
			template,
			setup() {
				return { faq: store };
			},
		});
	}
}